<template>
  <div class="login-wrap">
    <div class="header_logo">
        <el-image style="cursor:pointer" class="logo" @click="$router.push('/')" :src="logo" fit="fill">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
        </el-image>
    </div>
    <div class="minddle">
        <div class="formBox">
              <div class="login_text">注册</div>
              <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" class="demo-ruleForm">
                  <el-form-item prop="username">
                    <el-input type="text" v-model="ruleForm.username" autocomplete="off" placeholder="手机号"></el-input>
                  </el-form-item>
                  <el-form-item  prop="password">
                    <el-input type="password" v-model="ruleForm.password" autocomplete="off" placeholder="密码"></el-input>
                  </el-form-item>
                   <el-form-item  prop="passwordComfirm">
                    <el-input type="password" v-model="ruleForm.passwordComfirm" autocomplete="off" placeholder="密码"></el-input>
                  </el-form-item>
                  <el-form-item class="codeImgText" prop="code">
                    <!-- <el-input  v-model="ruleForm.code" autocomplete="off" placeholder="验证码"></el-input> -->
                    <el-input type="text" placeholder="验证码" v-model="ruleForm.code" style="height: 45px">
                      <template slot="append">
<!--                        <div  @click="refreshCode" class="codeImg">-->
<!--                            <s-identify :identifyCode="identifyCode"></s-identify>-->
<!--                        </div>-->
                        <!-- <el-image @click="flashImg" class="codeImg" title="点击刷新验证码" :src="require('@/assets/images/logo.png')" fit="fill">
                              <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"></i>
                              </div>
                        </el-image> -->
                        <div  class="codeImg">
                          <img :src="verifyCode" @click="getVerifyCode" alt="验证码"
                               style="height: 45px; width: 156px; border-radius: 4px;">
                        </div>
                      </template>
                    </el-input>
                  </el-form-item>
                  <el-form-item class="codePhoneText"  prop="codePhone">
                    <!-- <el-input type="password" v-model="ruleForm.codePhone" autocomplete="off" placeholder="输入短信验证码"></el-input> -->
                    <el-input type="text" placeholder="输入短信验证码" v-model="ruleForm.codePhone">
                      <template slot="append">
                          <el-button class="getMessageText" :disabled='codeDisabled' @click="sendSmsRegister" v-if="!isShowButton">获取短信验证码</el-button>
                          <p class="getMessageText" v-if="isShowButton">{{count}}秒后重新获取</p>
                      </template>
                    </el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="submitForm()">注册</el-button>
                  </el-form-item>
              </el-form>
              <!-- <p class="agrreUserText">点击注册表示同意 <a target="_blank" @click="$router.push('#/userAgreement')"> 用户协议</a> <a href="#/userAgreement">商家入驻</a></p> -->
              <p class="agrreUserText">点击注册表示同意 <router-link to="/userAgreement"> 用户协议</router-link></p>
               <div class="textBox">
                 <a class="passtext" @click="$router.push('/retrievePassword')">登录遇到问题</a>
                  <el-divider direction="vertical"></el-divider>
                 <a class="creatText" @click="$router.push('/login')">我已注册,现在登录</a>
              </div>
        </div>
    </div>
    <div class="footer_info">
        <p class="text-center" style="line-height: 30px;">{{informations.copyrightInformation}}<br>
          <a :href="informations.icpUrl" target="_blank">{{informations.icp}}</a>
        </p>
    </div>
    <div style="align-items: center; text-align: center;display: flex; justify-content: center;">
      <el-image
        class="copyright_img"
        :src="require('@/assets/img/Nationa_Lemblem.png')"            style="margin-right: 5px;"
      ></el-image>
      <a href="https://beian.mps.gov.cn/#/query/webSearch?code=46010002001073" rel="noreferrer" target="_blank">琼公网安备46010002001073号</a>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { login,sendSms,register,copyRight,setImage } from "@/api/xunyou";
import { setCookie, getCookie, delCookie } from '../utils/util'
import SIdentify from '@/components/sidentify'
import md5 from 'js-md5'
import {getVerifyCode,sendSmsRegister} from "../api/xunyou";
export default {
  name: 'login',
  components: { SIdentify },
  data() {
    return {
      logo:'',
      informations:{},
      isShowButton:false,
      identifyCodes: "1234567890",
      identifyCode: "",
      //注册
      ruleForm: {
        //username和password默认为空
        username: '',
        password: '',
        passwordComfirm:'',
        code:'',
        codePhone:'',
        isNotCode: true,
        verifyCode: '',
        uuid: ''
      },
      bizId: '',
      sendTime:'',
      count: '',
      timer: null,
      sendCode: true,
      codeDisabled:false,
      verifyCode: '', //验证码
      uuid: '',
      //rules前端验证
      rules: {
        // username: [
        //   { required: true, message: '请输入手机号', trigger: 'blur' },
        //   {
        //     pattern: /^1(3\d|47|5((?!4)\d)|7(0|1|[6-8])|8\d)\d{8,8}$/,
        //     required: true,
        //     message: '请输入正确的手机号',
        //     trigger: 'blur',
        //   }],
        // password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        // code: [{ required: true,
        //           message: '请输入验证码',
        //             trigger: 'blur',
        //             validator:(rule, value, callback) => {
        //                 console.log(rule, value,'验证码校验')
        //                 if (value === '') {
        //                   callback(new Error('请输入验证码'));
        //                 } else if (this.identifyCode !== value) {
        //                   this.ruleForm.code ='',
        //                   this.refreshCode()
        //                 }else{
        //                   callback();
        //                 }
        //               }
        //       }],
        codePhone: [{ required: true, message: '输入短信验证码', trigger: 'blur' }],
         password:[{ required: true,
             //  message: "不能为空",
              trigger: ["blur"],
              validator:(rule, value, callback) => {
                 let reg = new RegExp(/^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$)^.{6,16}$/)
                 let result = reg.test(value);
                 if (value == '') {
                     callback(new Error('不能为空'));
                 }else if (!result) {
                     callback(new Error('密码长度6~16位，其中数字，字母和符号至少包含两种'));
                 }else{
                     callback();
                 }
              }
         }],
        passwordComfirm:[{ required: true,
                // message: "不能为空",
                 trigger: ["blur"],
                validator:(rule, value, callback) => {
                    let regs = new RegExp(/^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$)^.{6,16}$/)
                    let results = regs.test(value);
                    if (value == '') {
                      callback(new Error('不能为空'));
                    }else if (!results) {
                        callback(new Error('密码长度6~16位，其中数字，字母和符号至少包含两种'));
                    }else if (value != this.ruleForm.password ) {
                      callback(new Error('两次密码不一致'));
                    }else{
                      callback();
                    }
                }
        }],
      }
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    // this.$message({
    //   message: '账号密码及验证码不为空即可',
    //   type: 'success'
    // })
    // // 获取图形验证码
    // this.getcode()
    // // 获取存在本地的用户名密码
    // this.getuserpwd()
    this.getImagelogo()
    this.geTCopyright()
    this.getVerifyCode();
  },
  mounted(){
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
  },
  // 里面的函数只有调用才会执行
  methods: {
      // 获取logo
    getImagelogo(){
      setImage().then(res=>{
          if(res.code==0){
            this.logo = res.rows[0].pcLogo
          }
        })
    },
    // 获取版权名称
    geTCopyright(){
      copyRight().then(res=>{
        if(res.code==0){
          this.informations = res.rows[0]
          if(this.informations.powstatus==1){
            this.$router.push('/erroPage')
          }else{
             this.$store.commit('getcopyRight',this.informations)
          }
        }
      }).catch(err=>{
        this.$message.error('查询失败,请稍后再试!')
      })
    },
    // 获取用户名密码
    // getuserpwd() {
    //   if (getCookie('user') != '' && getCookie('pwd') != '') {
    //     this.ruleForm.username = getCookie('user')
    //     this.ruleForm.password = getCookie('pwd')
    //     this.rememberpwd = true
    //   }
    // },

    //验证码
      randomNum(min, max) {
         return Math.floor(Math.random() * (max - min) + min);
      },

      refreshCode() {
        console.log('点击验证码刷新')
        this.identifyCode = "";
        this.makeCode(this.identifyCodes, 4);
      },

      makeCode(o, l) {
          for (let i = 0; i < l; i++) {
          this.identifyCode += this.identifyCodes[
            this.randomNum(0, this.identifyCodes.length)
          ];
          }
      },
      // 获取图形验证码
    async getVerifyCode() {
      this.uuid = this.generateUUID(); // 生成 UUID
      try {
        const response = await getVerifyCode({ uuid: this.uuid });
        console.log('获取验证码响应', JSON.stringify(response))
        const blob = await response.data;
        this.verifyCode = URL.createObjectURL(blob); // 将 Blob 转换为 URL
      } catch (error) {
        console.error('获取验证码失败', error);
      }
    },
    generateUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    // 获取短信验证码
    // getsendSms(){
    //
    //   if(this.ruleForm.username==''){
    //         this.$message({
    //              type: 'info',
    //              message: '请输入手机号'
    //          });
    //          return
    //   }
    //    if(this.ruleForm.code==''){
    //       this.$message({
    //              type: 'info',
    //              message: '请输入验证码'
    //          });
    //           return
    //   }
    //   this.codeDisabled = true
    //   sendSms({
    //       TemplateCode: 'SMS_180047841',
		// 			phoneNumbers: this.ruleForm.username
    //   }).then((res) => {
    //           this.$message({
    //             type: 'success',
    //             message: res.data
    //           });
    //           //发送成功
    //           const bizId = res.data.BizId;
    //           this.bizId=bizId;
    //           var nowDate = new Date();
    //           var year = nowDate.getFullYear();
    //           var month = nowDate.getMonth() + 1 < 10 ? "0" + (nowDate.getMonth() + 1)
    //             : nowDate.getMonth() + 1;
    //           var day = nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate
    //             .getDate();
    //
    //           this.sendTime=year+''+month+''+day;
    //
    //           const TIME_COUNT = 60;
    //           if (!this.timer) {
    //             this.isShowButton= true
    //             this.count = TIME_COUNT;
    //             this.sendCode = false;
    //             this.timer = setInterval(() => {
    //               if (this.count > 0 && this.count <= TIME_COUNT) {
    //                 this.count--;
    //               } else {
    //                 this.sendCode = true;
    //                 this.isShowButton= false
    //                 this.codeDisabled = false
    //                 clearInterval(this.timer);
    //                 this.timer = null;
    //               }
    //             }, 1000);
    //           }
    //           })
    //           .catch((err) => {
    //             this.loading = false;
    //             this.$message.error("发送短信验证码失败，请稍后再试！");
    //           });
    // },
    sendSmsRegister(){

      if(this.ruleForm.username==''){
        this.$message({
          type: 'info',
          message: '请输入手机号'
        });
        return
      }
      if(this.ruleForm.code==''){
        this.$message({
          type: 'info',
          message: '请输入验证码'
        });
        return
      }
      this.codeDisabled = true
      sendSmsRegister({
        phoneNumbers: this.ruleForm.username,
        uuid: this.uuid,
        captcha: this.ruleForm.code
      }).then((res) => {
        if(res.data.code === 0) {
          this.$message({
            type: 'success',
            message: res.data.msg
          });
          //发送成功
          const bizId = res.data.BizId;
          this.bizId=bizId;
          var nowDate = new Date();
          var year = nowDate.getFullYear();
          var month = nowDate.getMonth() + 1 < 10 ? "0" + (nowDate.getMonth() + 1)
            : nowDate.getMonth() + 1;
          var day = nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate
            .getDate();

          this.sendTime=year+''+month+''+day;

          const TIME_COUNT = 60;
          if (!this.timer) {
            this.isShowButton= true
            this.count = TIME_COUNT;
            this.sendCode = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.sendCode = true;
                this.isShowButton= false
                this.codeDisabled = false
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        } else {
          this.codeDisabled = false
          this.$message({
            type: 'error',
            message: res.data.msg
          });
        }
      })
        .catch((err) => {
          this.loading = false;
          this.$message.error("发送短信验证码失败，请稍后再试！");
        });
    },

    //注册
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        const req = {
            username: this.ruleForm.username,
            photo: this.ruleForm.username,
            password: this.ruleForm.password,
            bizId:this.bizId,
            sendTime:this.sendTime,
            validateCode: this.ruleForm.codePhone
        }
        if (valid) {

          register(req)
              .then((res) => {
                  if (res.code == 0) {
                    // this.$router.push({ path: `/initialPasswordSet?userId=${res.data||0}` }) // // 暂时不跳修改密码
                    this.$router.push({ path: `/login` })
                      this.$message({
                          type: 'success',
                          message: '注册成功!'
                      });
                  }else{
                    this.$message.error(res.msg);
                  }
              })
              .catch((err) => {
                this.loading = false;
                this.$message.error("注册失败，请稍后再试！");
              });
        } else {
          return false
        }
      })
    },

    // 获取验证码
    // flashImg(){
    //   console.log('点击验证码刷新')
    // }
  }
}
</script>

<style scoped lang='less'>
/deep/ .logo img{
  width: 255px;
  height: 52px;
}
.login-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 100%;

  .header_logo {
      padding: 30px 140px;
      margin: auto;
  }
  .minddle{
    background: url("~@/assets/img/registerBackground.jpeg") no-repeat;
    position: relative;
    background-repeat: no-repeat;
    background-size: cover;
    height: 670px;
    .formBox {
      //  width: 20%;
      width: 450px;
       background: white;
       position: absolute;
       right: 180px;
       top: 50%;
       padding: 40px 50px;
       transform: translate(0,-50%);
       padding: 40px 50px;

       .codeImgText{
         .el-image.codeImg {
              width: 150px;
              height: 100%;
              cursor: pointer;
          }
          /deep/.el-input-group__append{
            padding: 0;
          }

       }
        .codePhoneText{
          .getMessageText {
              display: block;
              color: white;
              font-size: 16px;
              width: 170px;
              cursor: pointer;
              text-align: center;
          }
          .getMessageText.el-button.is-disabled:hover{
              background-color:  #005ea7
          }
          /deep/.el-input-group__append {
             background: #4b5bff;
            color: white;
          }
          /deep/.el-input-group__append:hover {
              background: #5d6bff;
          }

        }
       .agrreUserText{
         font-size: 14px;
         color: #979898;
         span{
           color: #333;
           cursor: pointer;
         }
       }
       .login_text {
         color: #666;
         margin-bottom: 20px;
         color: rgba(151, 152, 152, 0.6);
         font-size: 20px;
      }
      button.el-button.el-button--primary {
          width: 100%;
          background-color: #394af8;
          border-color: #394af8;
      }
      button.el-button.el-button--primary:hover{
          background-color: #409eff;
          border-color: #409eff;
      }
      .textBox {
          text-align: right;
          font-size: 16px;
          a{
            color: #68b828;
            cursor: pointer;
          }
      }
    }
  }
  .footer_info {
    text-align: center;
    font-size: 14px;
    padding: 20px;
    p.text-center {
        color: #979898;
    }
  }
}
.login-container {
  border-radius: 10px;
  margin: 0px auto;
  width: 350px;
  padding: 30px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  text-align: left;
  box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1);
}
.title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}
.remember {
  margin: 0px 0px 35px 0px;
}
.code-box {
  text-align: right;
}
.copyright_img {
  width: 20px;
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/register.vue